var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H80C84.1421 0.5 87.5 3.85786 87.5 8V80C87.5 84.1421 84.1421 87.5 80 87.5H8C3.85786 87.5 0.5 84.1421 0.5 80V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    stroke: "#042761"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7059,
    y: 20.7059,
    width: 50.3529,
    height: 46.5882,
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9414 37.8823H29.2943",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8237 37.8823H58.4708",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2354 67.0588L46.2354 56.7059",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8237 20L52.8237 43.5294",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8823 20L35.8823 39.7647",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2939 36V39.7647",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4707 36V39.7647",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1177 56.7058L44.353 56.7058",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9414 43.5293L54.7061 43.5293",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8823 25.647H47.1764V37.8823H52.3529",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9414 52H53.7649",
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7059,
    y: 52.7059,
    width: 8.94118,
    height: 3.29412,
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7059,
    y: 56.4705,
    width: 8.94118,
    height: 3.29412,
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7059,
    y: 60.2352,
    width: 8.94118,
    height: 3.29412,
    stroke: "#042761",
    strokeWidth: 1.41176
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7059,
    y: 64.0001,
    width: 8.94118,
    height: 3.29412,
    stroke: "#042761",
    strokeWidth: 1.41176
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIcon1);
export default __webpack_public_path__ + "static/media/expIcon1.7603bf2e0cccaf3bdec48519ce41c888.svg";
export { ForwardRef as ReactComponent };